<script setup lang="ts">
import { Label, type LabelProps } from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<LabelProps & { class?: string }>();
</script>

<template>
    <Label
        v-bind="props"
        :class="
            cn(
                'text-sm font-medium tracking-tight text-iron-700 dark:text-stone-50 block text-left',
                props.class,
            )
        "
    >
        <slot />
    </Label>
</template>
